import * as services from "@api";
import { requiredValidate, getDataSourceByAlias, mergeDetailAddData } from "../utils";
import { PageStatusType } from '@stores/pagestore';

/**
 * add
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 *  billNo: string， 默认值：params.billNo
 * }
 * @returns
 */
export async function add(rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['cardStoreKey']);
  const { dataSourceAlias = '', cardStoreKey = 'cardStore' } = options;
  const { utils = {}, pageStore = {} } = rootStore;
  const { params = {}, query = {} } = pageStore;
  const cardStore = options.cardStore || rootStore.get(cardStoreKey);
  if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));

  // add请求里需要包装主组织字段的一些信息
  const formStore = rootStore.getStoreByAlias(cardStore.formStore)
  // masterOrgInfo是请求主组织相关信息的参数，后台根据masterOrgInfo的数据来包装主组织带入的数据
  const data = {}
  // params.orgId是切换ui模板功能带到新的模板主组织的值，未传此值的时候才需要后台包装主组织数据
  if (!params.hasOwnProperty('orgId') &&
      formStore?.masterOrgField) {
    Object.assign(data, { data: {
      ...formStore.masterOrgInfo,
      domain: formStore.masterOrgInfo.domain || params.domainKey
    }})
  }

  try {
    pageStore?.startLoading?.(); 
    const addRes = await services.add({
      params: {
        ...query,
        busiObj: options.busiObj || query.busiObj,
        datasource: dataSourceAlias || cardStore?.dataSource || '',
        billnum: options.billNo || params.billNo,
        mode: cardStore.uiState || pageStore.status,
        billId: "",
      },
      data
    });

    // add接口返回的数据剔除主组织，主组织需要通过masterOrgInfo带入
    if (addRes.data?.masterOrgKeyField) {
      delete addRes.data[addRes.data.masterOrgKeyField]
    }

    // 数据回写
    if (options.data) {
      const [ dataSource ] = getDataSourceByAlias(dataSourceAlias || cardStore?.dataSource, rootStore.dataSource);
      const mergeRes = mergeDetailAddData(dataSource, options.data, addRes.data);
      cardStore.setValue(mergeRes);
    } else {
      cardStore.add(addRes.data);
    }

    // add接口返回的数据有masterOrgInfo的话就触发参照带入，把主组织的相关字段带入
    if (addRes.data?.masterOrgInfo && formStore.masterOrgField) {
      const [firstItem] = Object.values(addRes.data.masterOrgInfo)
      if (firstItem.length) {
        const orgData = firstItem[0]
        // masterOrgInfo多语环境下，返回的name是对象，要根据环境取值
        if (typeof orgData.name === 'object') {
          let locale = pageStore.context?.locale ?? 'zh-CN'
          locale = locale.replace('-', '_')
          orgData.name = orgData.name[locale]
        }
        await formStore.get(formStore.masterOrgField).setValue(orgData, false)
      }
    }

    // 设置formstore里交易类型的信息
    if (addRes.data?.transTypeKeyField) {
      formStore.setTransTypeField(addRes.data.transTypeKeyField)
    }

    // 重置状态
    cardStore.setUiState(PageStatusType.ADD);
    Object.assign(params, { billId: '', code: '' });

    // 树表关联关系
    if (params.foreignKey) {
      formStore?.setValue?.(params.foreignKey, params.treeKey);
    }

    return addRes;
  } catch (err: any) {
    utils.message.danger(err?.message);
    return Promise.reject(err);
  } finally {
    pageStore?.endLoading?.();
  }
}
